import { useNavigate } from "react-router-dom";
import { Card } from "../../../components/card/card.jsx";

import TableBody from "../../../components/table/TableBody.jsx";

function Payments() {
	const navigate = useNavigate();

	const handleAddPayment = (send) => {
		navigate("/paymentsDetails", { state: send });
	};

	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<h1 className="page-header mb-0">Pagos</h1>
				</div>
				<div className="ms-auto">
					<button onClick={() => handleAddPayment({ type: "add" })} className="btn btn-outline-theme">
						<i className="fa fa-plus-circle fa-fw me-1"></i> Agregar Pagos
					</button>
				</div>
			</div>

			<Card>
				<div className="tab-content p-4">
					<div className="tab-pane fade show active" id="allTab">
						<div className="input-group mb-4">
							<div className="flex-fill position-relative">
								<div className="input-group"></div>
							</div>
						</div>

						<TableBody table={"payments"} />
					</div>
				</div>
			</Card>
		</div>
	);
}

export default Payments;
